module.exports = __webpack_public_path__ + "img/brewmaster.3fa4e605.jpg";